export var ACTION;
(function (ACTION) {
    ACTION["CAMERA_ACTION"] = "CAMERA_ACTION";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["RETAKE_PHOTO"] = "RETAKE_PHOTO";
    ACTION["FINAL_PHOTO_VERIFY"] = "FINAL_PHOTO_VERIFY";
    ACTION["CONTINUE_TO_NEXT_STEP"] = "CONTINUE_TO_NEXT_STEP";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["ON_MODAL_CLOSE_ACTION"] = "ON_MODAL_CLOSE_ACTION";
    ACTION["GENERATE_SHARE_LINK"] = "GENERATE_SHARE_LINK";
    ACTION["ON_CLICK_SHARE"] = "ON_CLICK_SHARE";
    ACTION["ON_CLICK_COPY"] = "ON_CLICK_COPY";
})(ACTION || (ACTION = {}));
